import { render, staticRenderFns } from "./ActiveControls.vue?vue&type=template&id=22e97dac&scoped=true&"
import script from "./ActiveControls.vue?vue&type=script&lang=js&"
export * from "./ActiveControls.vue?vue&type=script&lang=js&"
import style0 from "./ActiveControls.vue?vue&type=style&index=0&id=22e97dac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e97dac",
  null
  
)

export default component.exports